import ExportRegistry from './ExportRegistry';
flarum.reg = new ExportRegistry();